// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"b13c5","breadcrumb":"_2LEz-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/album/AlbumBreadcrumbs.css
// module id = 814
// module chunks = 0